export default "__VITE_ASSET__Blu4ALBF__"